export default __webpack_public_path__ + "assets/images/g-icon2-32298033.svg";